import OnDemandDevelopers from "../on-demand-developers";
import ProjectByEquity from "../project-by-equity";
import FullProjectDevelopment from "../full-project-development";
import WhatServices from "../what-services";
import Confirmation from "../confirmation";
import NavBar from "../nav-bar";
// import Intro from "../Intro";
import OurServices from "../our-services";
// import SeeOurWork from "../see-our-work";
// import ImpactAcrossIndustries from "../impact-across-industries";
// import WhatMakeUsDifferent from "../what-make-us-different";
// import WhatOurClientSays from "../what-our-client-says";
// import MeetOurTeam from "../meet-our-team";
// import AboutUs from "../about-us";
import Grid from "@mui/material/Grid/Grid";
import {CustomLabelMediumBold, CustomLabelMediumRegular} from "../common/CustomLabel";
import Box from "@mui/material/Box/Box";
import IPHONE151 from "../../assets/images/iPhone 15 Pro-1.png";
import ContactUs from "../contact-us";
import Footer from "../footer";
import React, {useRef, useState} from "react";
import {useMediaQuery} from "@mui/material";
import createTheme from "@mui/material/styles/createTheme";
import IntroDetails from "../intro-details";
// import WorkDetails from "../work-details";
// import PROJECT1 from "../../assets/images/project_1.png";
// import PROJECT2 from "../../assets/images/project2.png";
// import PROJECT3 from "../../assets/images/project3.png";
import WorkCard from "../card-work";
import Certificate1 from "../../assets/images/certificate.png";


const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg: 1300,
            xl: 1350,
        },
    },
});


const Certifications = ({}) => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);


    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);


    const CertificatesList = [
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description:"Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description:"Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description:"Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description:"Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description:"Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description:"Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description:"Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description:"Ensuring top-tier quality and customer satisfaction in all our processes."
        },
    ]


    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }

            <NavBar isMenuClicked={isMenuClicked} serviceRef={serviceRef} portfolioRef={portfolioRef}
                    testimonalsRef={testimonalsRef} partnersRef={partnersRef} setIsMenuClicked={setIsMenuClicked}
                    contactUsRef={contactUsRef}
                    setShowWhatService={setShowWhatService}/>


            <IntroDetails title={"Our Commitment to Excellence & Industry Standards"}
                          description={"We take pride in maintaining the highest standards of quality, security, and innovation. Our certifications reflect our expertise, commitment to best practices, and dedication to delivering exceptional solutions. Explore our recognized achievements below."}
            />




            <Grid item xs={12} container
                  justifyContent={"center"}
                  sx={{
                      marginTop: "40px",gap:"5px",
                  }}>

                {
                    CertificatesList.map((blog) =>
                        <Grid item xs={11} md={5.5} lg={3.5}>
                            <WorkCard {...blog} type={2}/>
                        </Grid>
                    )
                }


            </Grid>
            <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                         setShowWhatService={setShowWhatService}
                         setShowFullProject={setShowFullProject}
                         setShowProjectByEquity={setShowProjectByEquity}/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"HGot an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions. "}
                    />
                </Grid>


                <Grid item container xs={12} justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8}
                          sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                        <Box component={"img"} src={IPHONE151} alt={"OSTRYX"}
                             sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>

                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            <Footer/>

        </Grid>
    )
}

export default Certifications;
